import * as React from 'react';
export class Defs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    setDefs(defs) {
        // setting the state will re-render this component
        this.setState({ defs: Object.assign({}, defs) });
    }
    render() {
        const { defs } = this.state;
        return defs ? (React.createElement("defs", null, Object.keys(defs).map(id => (React.createElement(React.Fragment, { key: id }, defs[id].node))))) : null;
    }
}
//# sourceMappingURL=Defs.js.map